import type { ReactNode } from "react";

interface SheetContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Shared container component for sheet layouts.
 * Provides consistent padding, max-width, and flex layout.
 */
export function SheetContainer({ children, className }: SheetContainerProps) {
  return (
    <div
      className={`w-full max-w-2xl mx-auto flex flex-col p-6 text-foreground ${className || ""}`}
    >
      {children}
    </div>
  );
}


